import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false,
})
export class LoginComponent implements OnDestroy {
  color: string = 'primary';
  hintLabel_comp: string = '<span>message</span>';
  subscriptionLogin: Subscription = new Subscription();

  loginForm: FormGroup = this.fBuilder.group({
    email: ['', Validators.required],
    password: ['', Validators.required],
  });

  constructor(
    private readonly router: Router,
    private authService: AuthService,
    private fBuilder: FormBuilder,
    private readonly oidcSecurityService: OidcSecurityService
  ) {}

  login(): void {
    this.subscriptionLogin = this.authService.login().subscribe(() => {
      this.router.navigate(['./']);
    });
  }

  isAuth() {
    return this.router.navigate(['./']);
  }

  onSubmit() {
    const tokenStr: string | null = localStorage.getItem('tokenObj');
    if (!tokenStr) this.oidcSecurityService.authorize();
    else {
      this.router.navigate(['/']);
    }
  }

  ngOnDestroy() {
    this.subscriptionLogin?.unsubscribe();
  }
}
